<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('produitPresse.formatProduit.title') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('produitPresse.formatProduit.typeFormatPresse')">
          <b-select expanded v-model="produit.typeFormatPresseId">
            <option :value="null"></option>
            <option v-for="(type) in typesFormatPresse"
                    :key="type.id"
                    :value="type.id">
              {{ type.code + ' - ' + type.libelle }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('produitPresse.formatProduit.largeurPleinPapier')">
          <b-input v-model="produit.largeurPleinPapier" type="number" step="0.01"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('produitPresse.formatProduit.hauteurPleinPapier')">
          <b-input v-model="produit.hauteurPleinPapier" type="number" step="0.01"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('produitPresse.formatProduit.largeurFormatUtile')">
          <b-input v-model="produit.largeurFormatUtile" type="number" step="0.01"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('produitPresse.formatProduit.hauteurFormatUtile')">
          <b-input v-model="produit.hauteurFormatUtile" type="number" step="0.01"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('produitPresse.formatProduit.margeHaut')">
          <b-input v-model="produit.margeHaut" type="number" step="0.01"></b-input>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('produitPresse.formatProduit.margeGauche')">
          <b-input v-model="produit.margeGauche" type="number" step="0.01"></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { getAll } from '@/api/presse/typeFormatPresse/';

export default {
  name: 'formatProduitPresse',
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      typesFormatPresse: [],
    };
  },
  async mounted() {
    this.typesFormatPresse = (await getAll({ query: {} }))
      .data.result.items;
  },
};
</script>

<style scoped>

</style>
